import { FormEvent, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api, ApiError } from '../../lib/api'
import { trackEvent } from '../../lib/config'
import { SubmitButton } from '../../components/common'
import { AuthAlerts, AuthLayout, AuthLogo, LoginForm } from './AuthLayout'

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [errors, setErrors] = useState<string[]>([])
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    if (submitting) {
      return
    }
    setSubmitting(true)
    setErrors([])
    try {
      const result = await api.put<{ redirect: string }>('/professionals/password', {
        professional: {
          reset_password_token: searchParams.get('reset_password_token') ?? '',
          password,
          password_confirmation: passwordConfirmation,
        },
      })
      trackEvent('Password Reset Completed', undefined, { transport: 'sendBeacon' })
      window.location.assign(result.redirect)
    } catch (requestError) {
      const body = requestError instanceof ApiError ? (requestError.body as { errors?: string[] } | null) : null
      setErrors(body?.errors ?? ['Ocurrió un error, inténtalo nuevamente'])
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout>
      <AuthAlerts notices={[]} errors={errors} />
      <LoginForm onSubmit={(event) => void handleSubmit(event)}>
          <AuthLogo />
          <div className="row">
            <div className="col-xs-12 text-center" style={{ padding: 20 }}>
              <p>Cambia tu contraseña</p>
            </div>
          </div>
          <div className="form-group col-xs-12">
            <input
              type="password"
              className="form-control"
              placeholder="Contraseña"
              autoFocus
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <i className="fa fa-user" />
          </div>
          <div className="form-group col-xs-12">
            <input
              type="password"
              className="form-control"
              placeholder="Confirma tu contraseña"
              autoComplete="off"
              value={passwordConfirmation}
              onChange={(event) => setPasswordConfirmation(event.target.value)}
            />
            <i className="fa fa-lock" />
          </div>
          <div className="form-group col-xs-12">
            <SubmitButton label="Ingresar" block style={{ width: '100%' }} disabled={submitting} />
          </div>
          <section>
            <Link to="/professionals/sign_in">Iniciar sesión</Link>
            <br />
            <Link to="/professionals/sign_up">¿Quieres una nueva cuenta?</Link>
          </section>
      </LoginForm>
    </AuthLayout>
  )
}
